import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Place, PlaceImage } from '../models/place.model';
import { AppSettings } from '../app.settings';

@Component({
  selector: 'app-grouped-info-window-card',
  templateUrl: './grouped-info-window-card.component.html',
  styleUrls: ['./grouped-info-window-card.component.scss']
})
export class GroupedInfoWindowCardComponent implements OnInit {
  @Input()
  public groupedPlace: any;

  @Input()
  pluginUrl: any;

  @Input()
  mapComponent: any;

  resultsUrl: string = AppSettings.RESULTS_URL;

  constructor() { }

  ngOnInit() {
  }

}
